import { Component, ChangeDetectionStrategy } from '@angular/core'

@Component({
    selector: 'app-release-notes-page',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: `./release-notes.html`,
    styles: [
        `
      :host {
        text-align: center;
        color: var(--text-primary);
      }

      /* Version labels: regular size/weight, but keep vertical rhythm. */
      :host h3 {
        font-size: 1em;
        font-weight: 400;
        margin-top: 1.25em;
        margin-bottom: 0.5em;
      }
    `
    ],
    standalone: false
})
export class ReleaseNotesPageComponent {
}
